import isEmpty from 'lodash.isempty';
import globals from '../../globals';
import { connectedStore } from '../../store';
import selectors from '../selectors';

const getWebsiteVariableByElement = (element) => {
  const store = connectedStore.get();
  const state = store.getState();
  const variables = selectors.getVariables(state);

  if (!element || isEmpty(variables)) return null;

  return Object.keys(variables).find((variable, index, variablesNames) => {
    const hasElementSetting = variables[variable].some((item) => {
      const global = globals.selectors.getGlobal(state, item.globalId);
      if (!global) return false;
      return element.closest(`${globals.constants.GLOBAL_TAG_NAME}[src*='${global.id}']`);
    });

    if (hasElementSetting) {
      return variablesNames[index];
    }
    return null;
  });
};

export default getWebsiteVariableByElement;
